import { forwardRef } from "react";
import { cn } from "@/shared/lib/cn";
import { Button, type ButtonProps } from "./Button";

export interface ToggleButtonProps extends Omit<ButtonProps, "variant" | "aria-pressed"> {
  pressed: boolean;
  /** Primary-colored selection for likes and favorites. */
  tone?: "neutral" | "accent";
  onPressedChange: (pressed: boolean) => void;
}

/** Independent toolbar toggles; use SegmentedControl for exclusive choices. */
export const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  function ToggleButton({ pressed, tone = "neutral", onPressedChange, onClick, className, ...props }, ref) {
    return <Button {...props} ref={ref} variant="ghost" aria-pressed={pressed}
      className={cn("studio-toggle", tone === "accent" && "studio-favorite", className)}
      onClick={(event) => { onClick?.(event); if (!event.defaultPrevented) onPressedChange(!pressed); }} />;
  },
);
